module.exports = __webpack_public_path__ + "img/Telos_Logo.0cea4a49.png";